import { useState } from 'react'

import { useCall } from '../hooks/useCall'
import { useToasts } from '@/hooks/useToasts'

import { Button, Icon, useDisclosure } from '@chakra-ui/react'

import { EmergencyCall } from '@/components/icons'
import { MixpanelDataIProps } from '@/features/incident-drawer'
import { useEmergencyCallIncidentCategoryLazyQuery } from '@/graphql/generated/hooks'

import { GlobalEmergencyCallModal } from './GlobalEmergencyCallModal'

interface GlobalEmergencyCallButtonIProps {
  mixpanelData?: MixpanelDataIProps
  variant?: string
}

export const GlobalEmergencyCallButton = ({
  mixpanelData,
  variant = 'danger',
  ...props
}: GlobalEmergencyCallButtonIProps) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const { openCall } = useCall()
  const { showError } = useToasts()
  const [getEmergencyCallIncidentCategory, { loading: isLoading }] =
    useEmergencyCallIncidentCategoryLazyQuery()
  const [emergencyCallCategoryId, setEmergencyCallCategoryId] = useState<
    string | null
  >(null)

  const handleEmergencyButtonClick = async () => {
    try {
      const { data: categoryData } = await getEmergencyCallIncidentCategory()
      const categoryId = categoryData?.emergencyCallIncidentCategory?.id

      if (!categoryId) {
        showError('Emergency call category not found. Please try again.')
        return
      }

      setEmergencyCallCategoryId(categoryId)
      onOpen()
    } catch (error) {
      showError(
        'Failed to load emergency call configuration. Please try again.'
      )
    }
  }
  const handleCallClick = (
    facilityId?: string,
    facilityName?: string,
    incidentId?: string,
    incidentDisplayId?: string,
    emergencyNumber?: string
  ) => {
    if (facilityId && incidentId && incidentDisplayId) {
      // Only call openCall after incident is created with real data
      const payload = {
        incidentId,
        incidentDisplayId,
        facilityName,
        emergencyNumber,
        facilityId,
      }
      openCall(payload, mixpanelData)
      return
    }
  }

  return (
    <>
      <Button
        _disabled={{
          opacity: 0.4,
          cursor: 'not-allowed',
        }}
        border='none'
        color='white'
        data-testid='GlobalEmergencyCall:button'
        disabled={false}
        fontSize='16px'
        isLoading={isLoading}
        onClick={handleEmergencyButtonClick}
        size='md'
        variant={variant}
        {...props}
        rightIcon={
          <Icon
            as={EmergencyCall}
            boxSize='18px'
            strokeColor='white'
            strokeWidth={4}
          />
        }
      >
        Emergency Call
      </Button>
      {isOpen && (
        <GlobalEmergencyCallModal
          emergencyCallCategoryId={emergencyCallCategoryId}
          handleOnClick={handleCallClick}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </>
  )
}
